module.exports = __webpack_public_path__ + "static/img/YD.50d5265.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/YD.png
// module id = iv/C
// module chunks = 34